import { useState } from 'react'
import { Plus } from 'lucide-react'

import { Field } from '../../components/Field'
import { useRoadbook } from '../../data/roadbookContext'
import { travelDay } from '../../lib/calendar'
import { today } from '../../lib/format'
import { categories } from '../../lib/seed'
import { activeStages } from '../../lib/trip'
import { fahrzeug } from '../../lib/vehicle'

export function ExpenseForm() {
  const { trip, addExpense } = useRoadbook()
  const stages = activeStages(trip)
  // Die Liste hängt am Fahrzeug: die erste Kategorie heisst wie das, was
  // getankt wird - „Benzin“ war sie, weil das Fahrzeug der ersten Reise einer
  // ist.
  const kategorien = categories(fahrzeug(trip).fuel)

  const [gewaehlteKategorie, setKategorie] = useState('')
  const [amount, setAmount] = useState('')
  const [note, setNote] = useState('')
  const [gewaehlt, setGewaehlt] = useState('')

  /**
   * Die Etappe, auf die die Ausgabe gebucht wird.
   *
   * Abgeleitet und nicht bloss gespeichert: die Auswahl wurde früher einmal
   * beim ersten Rendern gesetzt und danach nie wieder angefasst. In einer
   * Reise ohne Etappen stand dort die leere Zeichenkette, und sie blieb es
   * auch, nachdem im Reiter Etappen die erste Etappe entstanden war - jede
   * Ausgabe dieser Sitzung hing danach an keiner Etappe und tauchte in keiner
   * Auswertung je Tag auf. Dasselbe gilt für eine gewählte Etappe, die jemand
   * inzwischen gelöscht hat.
   */
  const stageId = stages.some((s) => s.id === gewaehlt) ? gewaehlt : (stages[0]?.id ?? '')

  /**
   * Die gewählte Kategorie - abgeleitet und nicht bloss gespeichert, aus
   * demselben Grund wie die Etappe darüber: wer im Reiter Daten das Fahrzeug
   * auf Diesel stellt, hätte sonst weiter „Benzin“ im Auswahlfeld stehen, und
   * das Feld zeigte einen Namen, den die Liste darunter nicht mehr kennt.
   */
  const category = kategorien.some((k) => k.key === gewaehlteKategorie)
    ? gewaehlteKategorie
    : (kategorien[0]?.key ?? 'Sonstiges')

  const betrag = Number(amount)
  const gueltig = amount !== '' && Number.isFinite(betrag) && betrag > 0

  function eintragen() {
    if (!gueltig) return
    addExpense({ category, amount: betrag, note, stageId, date: today() })
    setAmount('')
    setNote('')
  }

  return (
    <form
      className="ausgabenformular kein-druck"
      onSubmit={(e) => {
        e.preventDefault()
        eintragen()
      }}
    >
      <Field label="Kategorie">
        <select value={category} onChange={(e) => setKategorie(e.target.value)}>
          {kategorien.map((c) => (
            <option key={c.key} value={c.key}>
              {c.key}
            </option>
          ))}
        </select>
      </Field>
      <Field label="Betrag">
        <input
          type="number"
          inputMode="decimal"
          min={0}
          step={0.05}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </Field>
      <Field label="Wofür">
        <input value={note} onChange={(e) => setNote(e.target.value)} />
      </Field>
      <Field label="Etappe">
        <select value={stageId} onChange={(e) => setGewaehlt(e.target.value)}>
          {/*
            Ohne Etappen war das eine leere Auswahl ohne eine einzige Zeile.
            Die Ausgabe lässt sich trotzdem eintragen - sie gehört dann eben zu
            keinem Tag -, und das soll dastehen statt sich zu verstecken.
          */}
          {stages.length === 0 && <option value="">— noch keine Etappe —</option>}
          {stages.map((s) => (
            <option key={s.id} value={s.id}>
              {travelDay(stages, s)}. {s.to}
            </option>
          ))}
        </select>
      </Field>
      <button type="submit" className="knopf" disabled={!gueltig}>
        <Plus size={14} /> Eintragen
      </button>
    </form>
  )
}
